import { displayXhrError } from 'hb-react/frontoffice/utils/globalUtils';
import { CANCEL_FETCH_MESSAGE } from 'hb-react/shared/constants/cancelFetch';
import { axiosInstance as axios } from 'hb-react/shared/utils/axios';

import { PER_PAGE } from '../constants/perPage';

let xhrErrorIsDisplayedOnce = false;

export const getPeopleDirectoryUsers = ({
  cancelToken,
  filters,
  geoBoundingBoxFilter,
  onlyUsersCount,
  page,
  fetchPeopleDirectoryUsers,
  sortBy,
  signal,
}) => {
  const options = signal ? { signal } : { cancelToken: cancelToken.token };

  return axios
    .get(
      fetchPeopleDirectoryUsers({
        page,
        ...filters,
        query: {
          ...(filters?.query || {}),
          ...geoBoundingBoxFilter,
        },
        ...(sortBy?.value ?? {}),
        per_page: PER_PAGE,
        only_users_count: onlyUsersCount,
      }),
      options,
    )
    .then(({ data: { users, total_items: total } }) => ({
      total,
      users,
    }))
    .catch((error) => {
      if (error.message === CANCEL_FETCH_MESSAGE) {
        return;
      }
      if (!xhrErrorIsDisplayedOnce) {
        xhrErrorIsDisplayedOnce = true;
        displayXhrError(error);
      }
    });
};
